module.exports = __webpack_public_path__ + "static/car-loan-gem-nz-955a6458d0151e631476eb8d072a1066.png";